<template>
  <pt-detection-corpus-structure-new class="pt-detection-corpus-structure-new__withData"></pt-detection-corpus-structure-new>
</template>

<script>
import PtDetectionCorpusStructureNew from './index'
export default {
  name: 'pt-detection-corpus-structure-new__withData',
  components: {
    'pt-detection-corpus-structure-new': PtDetectionCorpusStructureNew
  }
}
</script>
